import styled from '@emotion/styled';

const IconWrapper = styled('span')`
    vertical-align: middle;
    margin-right: 5px;
`;

export default IconWrapper;
